import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiShoppingBag, FiTrash2, FiX } from 'react-icons/fi';
import { useCart } from '../../context/CartContext';
import './CartDrawer.css';

export default function CartDrawer({ open, onClose }) {
  const { items, inc, dec, remove, totalSum, totalQty } = useCart();
  const panelRef = useRef(null);

  function handleClose() {
    // Нельзя ставить aria-hidden на предка, пока внутри фокус (кнопка Закрыть)
    if (panelRef.current?.contains(document.activeElement)) {
      document.activeElement?.blur?.();
    }
    onClose?.();
  }

  useEffect(() => {
    if (!open) return undefined;
    const panel = panelRef.current;
    const onKey = (e) => e.key === 'Escape' && handleClose();
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
      if (panel?.contains(document.activeElement)) {
        document.activeElement?.blur?.();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, onClose]);

  return (
    <>
      <div className={`cd-overlay ${open ? 'is-open' : ''}`} onClick={handleClose} />
      <aside
        ref={panelRef}
        className={`cd-panel ${open ? 'is-open' : ''}`}
        aria-hidden={!open}
        inert={!open || undefined}
        aria-label="Корзина"
      >
        <header className="cd-head">
          <div>
            <b>Корзина</b>
            {totalQty > 0 && <span className="cd-count">{totalQty} шт.</span>}
          </div>
          <button type="button" className="cd-close" onClick={handleClose} aria-label="Закрыть">
            <FiX />
          </button>
        </header>

        <div className="cd-body">
          {items.length === 0 ? (
            <div className="cd-empty">
              <span className="cd-empty__ico" aria-hidden>
                <FiShoppingBag />
              </span>
              <p>Корзина пока пустая</p>
              <Link to="/catalog" className="cd-empty__btn" onClick={handleClose}>
                В каталог
              </Link>
            </div>
          ) : (
            <ul className="cd-list">
              {items.map((it) => (
                <li key={it.id} className="cd-item">
                  <Link
                    to={it.slug ? `/p/${it.slug}` : '#'}
                    className="cd-thumb"
                    onClick={handleClose}
                  >
                    {it.img ? (
                      <img src={it.img} alt={it.title || 'Товар'} />
                    ) : (
                      <div className="noimg" />
                    )}
                  </Link>

                  <div className="cd-main">
                    <Link
                      to={it.slug ? `/p/${it.slug}` : '#'}
                      className="cd-title"
                      onClick={handleClose}
                    >
                      {it.title || 'Товар'}
                    </Link>

                    <div className="cd-row">
                      <div className="cd-qty">
                        <button type="button" className="cd-btn" onClick={() => dec(it.id)} aria-label="Уменьшить">
                          −
                        </button>
                        <output className="cd-val" aria-live="polite">
                          {it.qty}
                        </output>
                        <button type="button" className="cd-btn" onClick={() => inc(it.id)} aria-label="Увеличить">
                          +
                        </button>
                      </div>
                      <div className="cd-price">
                        {((it.price || 0) * it.qty).toLocaleString('ru-RU')} ₽
                      </div>
                    </div>
                    <div className="cd-meta">
                      {(it.price || 0).toLocaleString('ru-RU')} ₽ / шт.
                    </div>
                  </div>

                  <button
                    type="button"
                    className="cd-remove"
                    onClick={() => remove(it.id)}
                    title="Убрать"
                    aria-label="Убрать"
                  >
                    <FiTrash2 />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <footer className="cd-foot">
            <div className="cd-sub">
              <span>Итого</span>
              <b>{totalSum.toLocaleString('ru-RU')} ₽</b>
            </div>
            <Link to="/cart" className="cd-checkout" onClick={handleClose}>
              Оформить заказ
            </Link>
            <button type="button" className="cd-continue" onClick={handleClose}>
              Продолжить покупки
            </button>
          </footer>
        )}
      </aside>
    </>
  );
}
